import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import InterCompanyDividendLetterReportCriteria from "./InterCompanyDividendLetterReportCriteria";

@NeoReport("InterCompanyDividendLetter", { hidden: true })
export default class InterCompanyDividendLetterReport extends Report<InterCompanyDividendLetterReportCriteria> {

    constructor(
        private investorApiClient = AppService.get(DomainTypes.ApiClients.Investor),
        private dataCache = AppService.get(DomainTypes.Services.DataCache)
    ) {
        super(InterCompanyDividendLetterReportCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.GridLayout md={3}>
                <Neo.FormGroup bind={this.criteria.meta.entityId} select={{ itemSource: this.dataCache.entities }} />
                <Neo.FormGroup bind={this.criteria.meta.dividendDate} />
                <Neo.FormGroup bindContext={this.criteria.meta.investorId}>
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.investorId}
                        bindDisplay={this.criteria.meta.investorName}
                        itemSource={this.investorApiClient.getInvestorLookups} />
                </Neo.FormGroup>
            </Neo.GridLayout>
        </div>;
    }
}